<template>
  <div class="preview-root">

    <!-- ══════════════════════════════════════
         FAKE DASHBOARD — Relatório Gráfico
    ══════════════════════════════════════ -->
    <div class="dashboard-bg" aria-hidden="true">

      <!-- ── Top bar ── -->
      <div class="dash-topbar">
        <div class="dash-topbar__left">
          <i class="mdi mdi-menu dash-topbar__hamburger"></i>
          <img
            :src="require('@/assets/images/zapermenu.png')"
            class="dash-topbar__logo"
            alt="ZaperMenu"
          />
        </div>

        <div class="dash-topbar__empresa">
          <i class="mdi mdi-magnify"></i>
          <span>Empresa</span>
          <i class="mdi mdi-chevron-down"></i>
        </div>

        <div class="dash-topbar__user">
          <i class="mdi mdi-bell-outline dash-topbar__bell"></i>
          <div class="dash-user-avatar">{{ firstName.charAt(0).toUpperCase() }}</div>
          <span class="dash-user-name">{{ firstName }}</span>
          <i class="mdi mdi-chevron-down"></i>
        </div>
      </div>

      <!-- ── Layout: sidebar + conteúdo ── -->
      <div class="dash-body">

        <!-- Sidebar -->
        <aside class="dash-sidebar">

          <!-- Logo area -->
          <div class="dash-sidebar__logo">
            <div class="dash-sidebar__logo-icon">
              <i class="mdi mdi-food"></i>
            </div>
            <div class="dash-sidebar__logo-text">
              <div class="dash-sidebar__logo-name">Diego Pizzas</div>
              <div class="dash-sidebar__logo-sub">Administrador</div>
            </div>
          </div>

          <!-- Nav -->
          <nav class="dash-sidebar__nav">

            <div class="dash-nav-item">
              <i class="mdi mdi-home-outline dash-nav-icon"></i>
              <span>Início</span>
            </div>
            <div class="dash-nav-item">
              <i class="mdi mdi-domain dash-nav-icon"></i>
              <span>Nova Empresa</span>
            </div>
            <div class="dash-nav-item dash-nav-item--has-sub">
              <i class="mdi mdi-clipboard-list-outline dash-nav-icon"></i>
              <span>Cadastros</span>
              <i class="mdi mdi-chevron-right dash-nav-caret"></i>
            </div>
            <div class="dash-nav-item dash-nav-item--has-sub">
              <i class="mdi mdi-cash-register dash-nav-icon"></i>
              <span>Operações de Caixa</span>
              <i class="mdi mdi-chevron-right dash-nav-caret"></i>
            </div>
            <div class="dash-nav-item">
              <i class="mdi mdi-account-group-outline dash-nav-icon"></i>
              <span>Clientes</span>
            </div>
            <div class="dash-nav-item">
              <i class="mdi mdi-account-multiple-outline dash-nav-icon"></i>
              <span>Colaboradores</span>
            </div>
            <div class="dash-nav-item">
              <i class="mdi mdi-tag-outline dash-nav-icon"></i>
              <span>Cupons</span>
            </div>
            <div class="dash-nav-item dash-nav-item--has-sub">
              <i class="mdi mdi-truck-fast-outline dash-nav-icon"></i>
              <span>Taxas de Entrega</span>
              <i class="mdi mdi-chevron-right dash-nav-caret"></i>
            </div>
            <div class="dash-nav-item">
              <i class="mdi mdi-bank-outline dash-nav-icon"></i>
              <span>Contas a Pagar/Receber</span>
            </div>

            <!-- Relatórios — ativo + expandido -->
            <div class="dash-nav-item dash-nav-item--active dash-nav-item--has-sub">
              <i class="mdi mdi-chart-bar dash-nav-icon"></i>
              <span>Relatórios</span>
              <i class="mdi mdi-chevron-down dash-nav-caret"></i>
            </div>
            <div class="dash-nav-sub">
              <div class="dash-nav-sub-item">
                <i class="mdi mdi-clipboard-text-outline"></i>
                <span>Relatório de Pedidos</span>
              </div>
              <div class="dash-nav-sub-item dash-nav-sub-item--active">
                <i class="mdi mdi-chart-donut"></i>
                <span>Relatório Gráfico</span>
              </div>
              <div class="dash-nav-sub-item">
                <i class="mdi mdi-table-large"></i>
                <span>Relatório Financeiro</span>
              </div>
            </div>

            <div class="dash-nav-item">
              <i class="mdi mdi-file-document-outline dash-nav-icon"></i>
              <span>Notas Fiscais</span>
            </div>
            <div class="dash-nav-item">
              <i class="mdi mdi-gift-outline dash-nav-icon"></i>
              <span>Programa de Fidelidade</span>
            </div>
            <div class="dash-nav-item">
              <i class="mdi mdi-bullhorn-outline dash-nav-icon"></i>
              <span>Campanhas</span>
            </div>
            <div class="dash-nav-item">
              <i class="mdi mdi-account-supervisor-outline dash-nav-icon"></i>
              <span>Públicos</span>
            </div>
            <div class="dash-nav-item dash-nav-item--has-sub">
              <i class="mdi mdi-silverware-fork-knife dash-nav-icon"></i>
              <span>KDS</span>
              <i class="mdi mdi-chevron-right dash-nav-caret"></i>
            </div>
            <div class="dash-nav-item">
              <i class="mdi mdi-tablet dash-nav-icon"></i>
              <span>Tablets de Mesa</span>
            </div>
            <div class="dash-nav-item">
              <i class="mdi mdi-whatsapp dash-nav-icon"></i>
              <span>Conexões Whatsapp</span>
            </div>
            <div class="dash-nav-item">
              <i class="mdi mdi-cog-outline dash-nav-icon"></i>
              <span>Configurações</span>
            </div>

          </nav>
        </aside>

        <!-- ── Conteúdo principal ── -->
        <main class="dash-main">

          <!-- Breadcrumb / título -->
          <div class="dash-page-header">
            <div class="dash-breadcrumb">
              <span class="dash-breadcrumb__item">Relatórios</span>
              <i class="mdi mdi-chevron-right dash-breadcrumb__sep"></i>
              <span class="dash-breadcrumb__item dash-breadcrumb__item--active">Relatório Gráfico</span>
            </div>
            <div class="dash-header-actions">
              <div class="dash-period-btn">
                <i class="mdi mdi-calendar-range"></i>
                <span>Mês Passado</span>
                <i class="mdi mdi-chevron-down"></i>
              </div>
              <div class="dash-btn-icon">
                <i class="mdi mdi-refresh"></i>
              </div>
              <div class="dash-btn-icon">
                <i class="mdi mdi-download-outline"></i>
              </div>
            </div>
          </div>

          <!-- Grid de métricas -->
          <div class="dash-metrics">
            <div class="dash-metric" v-for="m in metrics" :key="m.label">
              <div class="dash-metric__icon-wrap" :style="{ background: m.color + '18', borderColor: m.color + '30' }">
                <i :class="'mdi mdi-' + m.icon" :style="{ color: m.color }"></i>
              </div>
              <div class="dash-metric__body">
                <div class="dash-metric__label">{{ m.label }}</div>
                <div class="dash-metric__value">{{ m.value }}</div>
                <div v-if="m.badge" class="dash-metric__badge">
                  <i class="mdi mdi-arrow-up-thin"></i>{{ m.badge }}
                </div>
              </div>
            </div>
          </div>

          <!-- Gráficos -->
          <div class="dash-charts">
            <div class="dash-chart-box">
              <div class="dash-chart-header">
                <span class="dash-chart-title">TOP 10 PRODUTOS MAIS VENDIDOS</span>
                <span class="dash-chart-sub">por receita (R$)</span>
              </div>
              <div class="dash-chart-area">
                <div class="dash-pie-wrap">
                  <div class="dash-pie" style="background: conic-gradient(#e53935 0% 44%, #1565c0 44% 62%, #43a047 62% 76%, #f9a825 76% 88%, #9c27b0 88% 100%)"></div>
                  <div class="dash-pie-hole"></div>
                </div>
                <div class="dash-legend">
                  <div class="dash-legend-item"><span class="dash-legend-dot" style="background:#e53935"></span>Hambúrguer Artesanal<strong>44%</strong></div>
                  <div class="dash-legend-item"><span class="dash-legend-dot" style="background:#1565c0"></span>Fritas Especiais<strong>18%</strong></div>
                  <div class="dash-legend-item"><span class="dash-legend-dot" style="background:#43a047"></span>Coca-Cola Lata<strong>14%</strong></div>
                  <div class="dash-legend-item"><span class="dash-legend-dot" style="background:#f9a825"></span>Onion Rings<strong>12%</strong></div>
                  <div class="dash-legend-item"><span class="dash-legend-dot" style="background:#9c27b0"></span>Outros<strong>12%</strong></div>
                </div>
              </div>
            </div>

            <div class="dash-chart-box">
              <div class="dash-chart-header">
                <span class="dash-chart-title">FATURAMENTO POR GRUPO</span>
                <span class="dash-chart-sub">por receita (R$)</span>
              </div>
              <div class="dash-chart-area">
                <div class="dash-pie-wrap">
                  <div class="dash-pie" style="background: conic-gradient(#e53935 0% 64%, #fb8c00 64% 84%, #8e24aa 84% 100%)"></div>
                  <div class="dash-pie-hole"></div>
                </div>
                <div class="dash-legend">
                  <div class="dash-legend-item"><span class="dash-legend-dot" style="background:#e53935"></span>Lanches<strong>64%</strong></div>
                  <div class="dash-legend-item"><span class="dash-legend-dot" style="background:#fb8c00"></span>Bebidas<strong>20%</strong></div>
                  <div class="dash-legend-item"><span class="dash-legend-dot" style="background:#8e24aa"></span>Sobremesas<strong>16%</strong></div>
                </div>
              </div>
            </div>
          </div>

        </main>
      </div>
    </div>

    <!-- ── Blur overlay ── -->
    <div class="blur-overlay" :class="{ 'blur-overlay--light': !$vuetify.theme.dark }" />

    <!-- ══════════════════════════════════════
         PAINEL DA JORNADA (overlay)
    ══════════════════════════════════════ -->
    <div class="journey-wrap">
      <div class="journey-panel" :class="{ 'journey-panel--light': !$vuetify.theme.dark }">

        <!-- Barra de progresso -->
        <div class="journey-progress">
          <div
            class="journey-progress__fill"
            :style="{ width: progressPct + '%' }"
          />
        </div>

        <transition :name="transitionName" mode="out-in">

          <!-- Info steps (quebra de objeções) -->
          <div
            v-if="currentStep.type === 'info'"
            :key="currentStep.id"
            class="journey-step"
          >
            <div class="info-icon">
              <i :class="'mdi mdi-' + currentStep.icon"></i>
            </div>
            <h3 class="journey-step__title">{{ currentStep.title }}</h3>
            <p class="journey-step__desc" v-html="currentStep.desc"></p>

            <div v-if="currentStep.note" class="info-note">
              <hr class="info-note__hr" />
              <p class="info-note__text">{{ currentStep.note }}</p>
            </div>

            <div v-if="currentStep.bullets" class="info-bullets">
              <div
                v-for="(b, i) in currentStep.bullets"
                :key="i"
                class="info-bullet"
              >
                <v-icon small color="success" style="flex-shrink:0">mdi-check-circle</v-icon>
                {{ b }}
              </div>
            </div>

            <button class="btn-journey mt-6" @click="nextStep">
              {{ isLastStep ? 'Ir para pagamento →' : 'Entendi, continuar →' }}
            </button>
          </div>

          <!-- Question steps -->
          <div
            v-else-if="currentStep.type === 'question'"
            :key="currentStep.id"
            class="journey-step"
          >
            <p class="journey-step-count">{{ questionNumber }} de {{ totalQuestions }}</p>
            <h3 class="journey-step__title">{{ currentStep.title }}</h3>
            <p v-if="currentStep.desc" class="journey-step__desc">{{ currentStep.desc }}</p>

            <!-- Single -->
            <div v-if="currentStep.qtype === 'single'" class="q-options">
              <button
                v-for="opt in currentStep.options"
                :key="opt.value"
                class="q-option"
                :class="{ 'q-option--selected': answers[currentStep.id] === opt.value }"
                @click="selectAnswer(opt.value)"
              >
                <i v-if="opt.icon" :class="'mdi mdi-' + opt.icon + ' q-option__icon'"></i>
                {{ opt.label }}
              </button>
            </div>

            <!-- Multiple -->
            <div v-else-if="currentStep.qtype === 'multiple'" class="q-options">
              <button
                v-for="opt in currentStep.options"
                :key="opt.value"
                class="q-option"
                :class="{ 'q-option--selected': (answers[currentStep.id] || []).includes(opt.value) }"
                @click="toggleMultiple(currentStep.id, opt.value)"
              >
                <i v-if="opt.icon" :class="'mdi mdi-' + opt.icon + ' q-option__icon'"></i>
                {{ opt.label }}
              </button>
            </div>

            <button
              v-if="currentStep.qtype === 'multiple'"
              class="btn-journey mt-5"
              :disabled="!(answers[currentStep.id] || []).length"
              @click="nextStep"
            >
              {{ isLastStep ? 'Concluir →' : 'Próxima →' }}
            </button>
          </div>

          <!-- Loading final -->
          <div v-else-if="currentStep.type === 'finish'" key="finish" class="journey-step journey-step--center">
            <div class="finish-spinner"></div>
            <h3 class="journey-step__title mt-4">Perfeito, {{ firstName }}!</h3>
            <p class="journey-step__desc">Preparando sua conta...</p>
          </div>

        </transition>
      </div>
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex';
import { trackClick } from '@/utils/lpTracker';

export default {
  name: 'Preview',

  data: () => ({
    stepIndex: 0,
    direction: 'next',
    answers: {},

    metrics: [
      { label: 'CLIENTES',           value: '247',        icon: 'account-group',         color: '#e53935', badge: '+8 hoje' },
      { label: 'TICKET MÉDIO',       value: 'R$ 54,30',   icon: 'credit-card-outline',   color: '#1565c0' },
      { label: 'TAXAS DE ENTREGA',   value: 'R$ 412,00',  icon: 'truck-fast-outline',    color: '#43a047' },
      { label: 'PEDIDOS',            value: '312',        icon: 'clipboard-text-outline', color: '#e91e63' },
      { label: 'AGENDAMENTOS',       value: '14',         icon: 'calendar-clock',        color: '#c62828' },
      { label: 'CUPONS UTILIZADOS',  value: '23',         icon: 'tag-outline',           color: '#00838f' },
      { label: 'TOTAL VENDAS',       value: 'R$ 16.941',  icon: 'cash-multiple',         color: '#f9a825' },
      { label: 'TOTAL CUSTOS',       value: 'R$ 3.210',   icon: 'chart-line',            color: '#4e342e' },
      { label: 'TOTAL LUCRO',        value: 'R$ 13.731',  icon: 'trending-up',           color: '#6a1b9a' },
      { label: 'VENDA COMPLEMENTAR', value: 'R$ 1.840',   icon: 'cart-plus',             color: '#2e7d32' },
      { label: 'PONTOS GERADOS',     value: '5.210',      icon: 'star-outline',          color: '#283593' },
      { label: 'PONTOS RESGATADOS',  value: '870',        icon: 'trophy-outline',        color: '#bf360c' },
    ],

    steps: [
      {
        id: 'welcome',
        type: 'info',
        icon: 'check-decagram',
        title: 'Parabéns! Cadastro concluído.',
        desc: 'Seja muito bem vindo! Esse é o <strong>Gestor de Pedidos ZaperMenu</strong> — aqui você vai ter acesso a tudo que o seu delivery precisa.',
        note: 'Antes de prosseguir, queremos te mostrar o que está incluso no seu plano.',
      },
      {
        id: 'garantia',
        type: 'info',
        icon: 'shield-check',
        title: 'Garantia incondicional de 30 dias',
        desc: 'Se em 30 dias você não estiver satisfeito por qualquer motivo, devolvemos <strong>100% do valor</strong> — sem burocracia, sem perguntas.',
        bullets: [
          'Solicitação simples pelo WhatsApp',
          'Devolução em até 5 dias úteis',
          'Sem letras miúdas ou pegadinhas',
        ],
      },
      {
        id: 'implementacao',
        type: 'info',
        icon: 'account-wrench',
        title: 'Um especialista configura tudo por você',
        desc: 'Após o pagamento um <strong>profissional experiente</strong> cuida de tudo gratuitamente.',
        bullets: [
          'Cadastro completo dos seus produtos',
          'Configuração do cardápio digital e QR Code',
          'Instalação e configuração do app e impressora',
          'Treinamento e acompanhamento para tirar dúvidas',
        ],
      },
      {
        id: 'sem_taxas',
        type: 'info',
        icon: 'cash-remove',
        title: 'Zero taxas sobre seus pedidos',
        desc: 'Diferente do iFood, você paga <strong>somente a mensalidade do plano</strong>. Nenhum centavo por pedido.',
        bullets: [
          'Sem comissão por pedido',
          'Sem limite de pedidos por mês',
          'Sem taxa de adesão',
        ],
      },
      {
        id: 'suporte',
        type: 'info',
        icon: 'headset',
        title: 'Suporte humanizado todos os dias',
        desc: 'Nenhum robô — só pessoas reais. Atendimento via <strong>WhatsApp</strong>, todos os dias.',
        bullets: [
          'Resposta em minutos, não em horas',
          'Time especializado em delivery',
          'Sem fila de espera ou ticket',
        ],
      },
      { id: 'finish', type: 'finish' },
    ],
  }),

  computed: {
    ...mapState(['selectedPlan', 'contatoUuid', 'quizAnswers']),

    currentStep() {
      return this.steps[this.stepIndex] || this.steps[this.steps.length - 1];
    },

    progressPct() {
      return (this.stepIndex / (this.steps.length - 1)) * 100;
    },

    transitionName() {
      return this.direction === 'next' ? 'slide-left' : 'slide-right';
    },

    firstName() {
      return this.quizAnswers?.nome?.split(' ')[0] || 'você';
    },

    totalQuestions() {
      return this.steps.filter(s => s.type === 'question').length;
    },

    questionNumber() {
      return this.steps.slice(0, this.stepIndex).filter(s => s.type === 'question').length + 1;
    },

    isLastStep() {
      return this.stepIndex === this.steps.length - 2;
    },
  },

  mounted() {
    if (!this.selectedPlan) {
      this.$router.replace('/');
    }
  },

  methods: {
    nextStep() {
      this.direction = 'next';
      if (this.isLastStep) {
        trackClick('Preview - Ir para pagamento');
        this.finish();
        return;
      }
      trackClick(`Preview - Continuar (${this.currentStep.id})`);
      if (this.stepIndex < this.steps.length - 1) this.stepIndex++;
    },

    selectAnswer(value) {
      trackClick(`Preview - Resposta (${this.currentStep.id}: ${value})`);
      this.$set(this.answers, this.currentStep.id, value);
      this.$nextTick(() => setTimeout(() => this.nextStep(), 220));
    },

    toggleMultiple(id, value) {
      const current = this.answers[id] || [];
      const idx = current.indexOf(value);
      this.$set(this.answers, id, idx === -1
        ? [...current, value]
        : current.filter(v => v !== value));
    },

    finish() {
      this.direction = 'next';
      this.stepIndex = this.steps.length - 1;
      this.$store.commit('mergeQuizAnswers', this.answers);
      setTimeout(() => this.$router.push('/pagamento'), 1800);
    },
  },
};
</script>

<style scoped lang="scss">

/* ══════════════════════════════════════
   ROOT
══════════════════════════════════════ */
.preview-root {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  background: #f0f2f5;
}

/* ══════════════════════════════════════
   FAKE DASHBOARD
══════════════════════════════════════ */
.dashboard-bg {
  position: fixed;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
  user-select: none;
  background: #f0f2f5;
  display: flex;
  flex-direction: column;
  font-family: "Poppins", Arial, sans-serif;
}

/* ── Top bar ── */
.dash-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 18px;
  height: 52px;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
  gap: 12px;

  &__left {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
  }

  &__hamburger {
    font-size: 20px;
    color: #555;
    flex-shrink: 0;
  }

  &__logo {
    height: 26px;
    width: auto;
    display: block;
    object-fit: contain;
  }

  &__empresa {
    display: flex;
    align-items: center;
    gap: 6px;
    background: #f8f9fa;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 5px 12px;
    font-size: 13px;
    color: #374151;
    white-space: nowrap;
    overflow: hidden;
    max-width: 260px;

    .mdi { font-size: 15px; color: #9ca3af; flex-shrink: 0; }
    span { overflow: hidden; text-overflow: ellipsis; }

    @media (max-width: 600px) { display: none; }
  }

  &__user {
    display: flex;
    align-items: center;
    gap: 7px;
    flex-shrink: 0;

    .mdi { font-size: 16px; color: #6b7280; }
  }

  &__bell { margin-right: 4px; }
}

.dash-user-avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #e53935;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.dash-user-name {
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  @media (max-width: 480px) { display: none; }
}

/* ── Body ── */
.dash-body {
  display: flex;
  flex: 1;
  overflow: hidden;
}

/* ── Sidebar ── */
.dash-sidebar {
  width: 224px;
  flex-shrink: 0;
  background: #fff;
  border-right: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  @media (max-width: 860px) { width: 200px; }
  @media (max-width: 640px) { width: 48px; }
  @media (max-width: 480px) { display: none; }

  &__logo {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 14px 14px 12px;
    border-bottom: 1px solid #f3f4f6;
    flex-shrink: 0;

    @media (max-width: 640px) { padding: 12px 10px; justify-content: center; }
  }

  &__logo-icon {
    width: 34px;
    height: 34px;
    border-radius: 8px;
    background: #e53935;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    .mdi { font-size: 18px; }
  }

  &__logo-text {
    min-width: 0;
    @media (max-width: 640px) { display: none; }
  }

  &__logo-name {
    font-size: 13px;
    font-weight: 600;
    color: #111827;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__logo-sub {
    font-size: 10px;
    color: #9ca3af;
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }

  &__nav {
    overflow: hidden;
    flex: 1;
    padding: 6px 0;
  }
}

/* Nav items */
.dash-nav-item {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 8px 14px;
  font-size: 12.5px;
  color: #4b5563;
  cursor: default;
  position: relative;

  @media (max-width: 640px) {
    padding: 10px;
    justify-content: center;
    span, .dash-nav-caret { display: none; }
  }

  span { flex: 1; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

  &:hover { background: #f9fafb; }

  &--active {
    background: #fff1f0;
    color: #e53935;
    font-weight: 600;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 3px;
      background: #e53935;
      border-radius: 0 2px 2px 0;
    }

    .dash-nav-icon { color: #e53935; }
    .dash-nav-caret { color: #e53935; }
  }
}

.dash-nav-icon {
  font-size: 17px;
  color: #6b7280;
  flex-shrink: 0;
}

.dash-nav-caret {
  font-size: 15px;
  color: #9ca3af;
  margin-left: auto;
  flex-shrink: 0;
}

/* Sub-nav */
.dash-nav-sub {
  background: #fafafa;
  border-left: 2px solid #f3f4f6;
  margin: 0 0 0 14px;

  @media (max-width: 640px) { display: none; }
}

.dash-nav-sub-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 14px;
  font-size: 12px;
  color: #6b7280;
  cursor: default;

  .mdi { font-size: 15px; color: #9ca3af; flex-shrink: 0; }
  span { flex: 1; }

  &--active {
    color: #e53935;
    font-weight: 600;
    background: #fff8f7;

    .mdi { color: #e53935; }
  }
}

/* ── Main content ── */
.dash-main {
  flex: 1;
  overflow: hidden;
  padding: 14px 14px 10px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
}

/* Page header */
.dash-page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border-radius: 10px;
  padding: 10px 16px;
  border: 1px solid #e5e7eb;
  flex-shrink: 0;
  gap: 12px;
}

.dash-breadcrumb {
  display: flex;
  align-items: center;
  gap: 4px;

  &__item {
    font-size: 13px;
    color: #9ca3af;
  }

  &__item--active {
    color: #111827;
    font-weight: 600;
  }

  &__sep {
    font-size: 14px;
    color: #d1d5db;
  }
}

.dash-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;

  @media (max-width: 600px) { display: none; }
}

.dash-period-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  color: #374151;
  background: #f9fafb;

  .mdi { font-size: 15px; color: #6b7280; }
}

.dash-btn-icon {
  width: 32px;
  height: 32px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #f9fafb;
  display: flex;
  align-items: center;
  justify-content: center;

  .mdi { font-size: 16px; color: #6b7280; }
}

/* ── Metrics grid ── */
.dash-metrics {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  flex-shrink: 0;

  @media (max-width: 900px) { grid-template-columns: repeat(2, 1fr); }
}

.dash-metric {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fff;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  padding: 10px 12px;

  &__icon-wrap {
    width: 42px;
    height: 42px;
    border-radius: 10px;
    border: 1px solid transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    .mdi { font-size: 20px; }
  }

  &__body {
    min-width: 0;
    flex: 1;
  }

  &__label {
    font-size: 9.5px;
    font-weight: 700;
    letter-spacing: 0.05em;
    color: #9ca3af;
    text-transform: uppercase;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__value {
    font-size: 16px;
    font-weight: 700;
    color: #111827;
    line-height: 1.25;
    white-space: nowrap;
  }

  &__badge {
    font-size: 10px;
    color: #16a34a;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 2px;

    .mdi { font-size: 12px; }
  }
}

/* ── Charts ── */
.dash-charts {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;

  @media (max-width: 700px) { grid-template-columns: 1fr; }
}

.dash-chart-box {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 14px 16px;
}

.dash-chart-header {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 14px;
}

.dash-chart-title {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.05em;
  color: #374151;
}

.dash-chart-sub {
  font-size: 10px;
  color: #9ca3af;
}

.dash-chart-area {
  display: flex;
  align-items: center;
  gap: 18px;
}

/* Donut chart */
.dash-pie-wrap {
  position: relative;
  width: 84px;
  height: 84px;
  flex-shrink: 0;
}

.dash-pie {
  width: 84px;
  height: 84px;
  border-radius: 50%;
}

.dash-pie-hole {
  position: absolute;
  inset: 18px;
  border-radius: 50%;
  background: #fff;
}

/* Legend */
.dash-legend {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  flex: 1;
}

.dash-legend-item {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 11px;
  color: #4b5563;
  min-width: 0;

  strong {
    margin-left: auto;
    font-weight: 600;
    color: #111827;
    flex-shrink: 0;
  }
}

.dash-legend-dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  flex-shrink: 0;
}

/* ══════════════════════════════════════
   BLUR OVERLAY
══════════════════════════════════════ */
.blur-overlay {
  position: fixed;
  inset: 0;
  backdrop-filter: blur(2px);
  background: rgba(0, 0, 0, 0.52);
  z-index: 10;

  &--light {
    background: rgba(0, 0, 0, 0.38);
  }
}

/* ══════════════════════════════════════
   JOURNEY PANEL
══════════════════════════════════════ */
.journey-wrap {
  position: fixed;
  inset: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 16px;
}

.journey-panel {
  background: #111;
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 24px;
  width: 100%;
  max-width: 460px;
  max-height: 90vh;
  overflow-y: auto;
  padding: 28px;

  @media (max-width: 520px) {
    padding: 22px 16px;
    border-radius: 16px;
  }

  &--light {
    background: #ffffff;
    border-color: rgba(0,0,0,0.08);
    box-shadow: 0 24px 64px rgba(0,0,0,0.18);
  }
}

/* Progress */
.journey-progress {
  height: 3px;
  background: rgba(255,255,255,0.08);
  border-radius: 2px;
  margin-bottom: 24px;
  overflow: hidden;

  .journey-panel--light & { background: #e5e7eb; }
}

.journey-progress__fill {
  height: 100%;
  background: linear-gradient(90deg, #f40612, #ff6b35);
  border-radius: 2px;
  transition: width 0.4s ease;
}

/* Step */
.journey-step {
  color: #fff;

  .journey-panel--light & { color: #111827; }

  &--center {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

.info-icon {
  margin-bottom: 14px;

  .mdi {
    font-size: 36px;
    color: #f40612;
  }

  .journey-panel--light & .mdi { color: #e53935; }
}

.journey-step__title {
  font-size: 19px;
  font-weight: 700;
  line-height: 1.3;
  margin-bottom: 10px;
  color: #fff;

  .journey-panel--light & { color: #111827; }
}

.journey-step__desc {
  font-size: 14px;
  line-height: 1.65;
  color: rgba(255,255,255,0.62);
  margin-bottom: 4px;

  .journey-panel--light & { color: #4b5563; }
}

.journey-step-count {
  font-size: 11px;
  color: rgba(255,255,255,0.35);
  margin-bottom: 10px;

  .journey-panel--light & { color: #9ca3af; }
}

/* Note (divider + texto) */
.info-note {
  margin-top: 16px;
  margin-bottom: 4px;

  &__hr {
    border: none;
    border-top: 1px solid rgba(255,255,255,0.1);
    margin: 0 0 12px;

    .journey-panel--light & { border-top-color: #e5e7eb; }
  }

  &__text {
    font-size: 13px;
    color: rgba(255,255,255,0.4);
    font-style: italic;
    margin: 0;

    .journey-panel--light & { color: #9ca3af; }
  }
}

.info-bullets {
  margin-top: 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.info-bullet {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: rgba(255,255,255,0.75);
  background: rgba(35,207,101,0.06);
  border: 1px solid rgba(35,207,101,0.15);
  border-radius: 10px;
  padding: 9px 12px;

  .journey-panel--light & {
    color: #1f2937;
    background: rgba(22,163,74,0.06);
    border-color: rgba(22,163,74,0.2);
  }
}

.q-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 14px;
}

.q-option {
  display: flex;
  align-items: center;
  gap: 9px;
  width: 100%;
  padding: 12px 14px;
  border-radius: 11px;
  border: 1px solid rgba(255,255,255,0.12);
  background: rgba(255,255,255,0.04);
  color: rgba(255,255,255,0.8);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  text-align: left;
  transition: all 0.18s;

  &:hover { border-color: rgba(255,255,255,0.28); background: rgba(255,255,255,0.08); }
  &--selected { border-color: #23cf65; background: rgba(35,207,101,0.1); color: #fff; }

  .journey-panel--light & {
    border-color: #e5e7eb;
    background: #f9fafb;
    color: #374151;

    &:hover { border-color: #9ca3af; background: #f3f4f6; }
    &.q-option--selected { border-color: #16a34a; background: rgba(22,163,74,0.08); color: #111827; }
  }
}

.q-option__icon {
  font-size: 17px;
  flex-shrink: 0;
  opacity: 0.75;

  .q-option--selected & { opacity: 1; }
}

.btn-journey {
  display: block;
  width: 100%;
  padding: 13px;
  border-radius: 12px;
  background: #f40612;
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  border: none;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover:not(:disabled) { opacity: 0.88; }
  &:disabled { opacity: 0.35; cursor: not-allowed; }
}

.finish-spinner {
  width: 44px;
  height: 44px;
  border: 3px solid rgba(255,255,255,0.1);
  border-top-color: #23cf65;

  .journey-panel--light & { border-color: #e5e7eb; border-top-color: #16a34a; }
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin { to { transform: rotate(360deg); } }

.mt-4 { margin-top: 16px; }
.mt-5 { margin-top: 20px; }
.mt-6 { margin-top: 24px; }

/* ── Transitions ── */
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active { transition: all 0.22s ease; }
.slide-left-enter  { opacity: 0; transform: translateX(30px); }
.slide-left-leave-to { opacity: 0; transform: translateX(-30px); }
.slide-right-enter { opacity: 0; transform: translateX(-30px); }
.slide-right-leave-to { opacity: 0; transform: translateX(30px); }
</style>
